"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function proxyMessagesObject(messages) {
    return new Proxy(messages, messageProxyHandler(""));
}
exports.proxyMessagesObject = proxyMessagesObject;
function messageProxyHandler(codePrefix) {
    return {
        get: function (target, p, receiver) {
            if (p in target) {
                var value = target[p];
                if (typeof value === 'string') {
                    return appendPrefix(codePrefix, p) + ": " + value;
                }
                else if (typeof value === 'object') {
                    return new Proxy(value, messageProxyHandler(appendPrefix(codePrefix, p)));
                }
                else {
                    return Reflect.get(target, p, receiver);
                }
            }
            else {
                return Reflect.get(target, p, receiver);
            }
        },
    };
}
function appendPrefix(prefix, suffix) {
    if (prefix === "") {
        return suffix.toString();
    }
    else {
        return prefix + "::" + suffix.toString();
    }
}
